<template>
  <div class="grid_header">
    <div class="cell justify-center"> {{ colName }}</div>
    <div>
      <div class="grid_quantity">
        <div class="cell">
          <div v-if="this.$slots.first" class="my-n1">
            <slot name="first"/>
          </div>
          <v-sheet color="transparent" width="100%" class="text-center">
            {{ t['reported'] }}
          </v-sheet>
        </div>
        <div class="cell justify-center">
          <div v-if="this.$slots.second" class="my-n1">
            <slot name="second"/>
          </div>
          <v-sheet color="transparent" width="100%" class="text-center">
            {{ t['invoiced'] }}
          </v-sheet>
        </div>
      </div>
      <div class="cell justify-center"> {{ t['quantity'] }}</div>
    </div>
    <div class="cell pl-8" :class="total ? 'one_col' : '' ">{{ t.work }}</div>
    <div v-if="!total" class="cell pl-8">Location</div>
    <div v-if="!total" class="cell pl-8">{{ t.note }}</div>
  </div>
</template>

<script>
export default {
  name: "StatisticProjectReportsBlankExcelTableHeader",
  props: {
    colName: {
      type: String,
      default: ''
    },
    total: Boolean
  },
  computed: {
    t() {
      return this.localStorage.translations.pages.finance['period-table']
    }
  }
}
</script>
